<nb-layout>
    <nb-layout-header  >
        <app-header></app-header>
    </nb-layout-header>
    <nb-layout-column   >
        <router-outlet ></router-outlet>
    </nb-layout-column>

    <nb-layout-footer  >
        <app-footer></app-footer>
    </nb-layout-footer>


</nb-layout>
